<template>
    <div>
        <template>
            <v-row v-if="cashCurrent == ''">
                <v-col cols="12" class="mt-5 pb-1">
                    <v-text-field
                        label="Ingrese monto de apertura"
                        outlined
                        hide-details
                        type="number"
                        v-model="amount_open"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-btn dark block height="48" color="#4CAF50" 
                        @click="handleOpenCash"
                        v-if="verifyPermission('abrir_caja_movimiento')">
                        <v-icon class="mr-2">fas fa-lock-open</v-icon>
                        Abrir Caja
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="cashCurrent != ''">
                <v-col cols="12">
                    <v-btn small dark block height="48" 
                        @click="handleCloseCash"
                        v-if="verifyPermission('cerrar_caja_movimiento')">
                        <v-icon class="mr-2" size="16">fas fa-lock</v-icon>
                        Cerrar Caja
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="cashCurrent != ''">
                <v-col cols="12">
                    <v-btn small dark block color="#34B362" height="48" 
                        @click="handleRegisterIncome"
                        v-if="verifyPermission('registrar_ingreso_movimiento')">
                        <v-icon class="mr-2" size="16">fas fa-download</v-icon>
                        Registar Ingreso
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="cashCurrent != ''">
                <v-col cols="12">
                    <v-btn small dark block color="#F96654" height="48" 
                        @click="handleRegisterExpense"
                        v-if="verifyPermission('registrar_egreso_movimiento')">
                        <v-icon class="mr-2" size="16">fas fa-upload</v-icon>
                        Registrar Egreso
                    </v-btn>
                </v-col>
            </v-row>            
        </template>
        <Form ref="form"></Form>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import Form from './Form'

export default {
    name: 'Actions',
    components: {
        Form
    },
    data() {
        return {
            amount_open: null,
            amount_close: null
        }
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ])
    },
    methods: {
        ...mapActions('cash', [
            'getCashCurrent',
            'openCash'
        ]),
        handleOpenCash(){
            if(this.amount_open == null || this.amount_open == '') {
                this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'RESULTADO DE OPERACIÓN',
                            text: 'Debe ingresar el monto!'
                        })
            } else {
                let data = {
                    amount_open: this.amount_open
                }
                this.openCash(data)
            }
        },
        handleRegisterIncome() {
            this.$refs.form.showForm('Registro de ingreso', 'income', this.cashCurrent.id)
        },
        handleRegisterExpense() {
            this.$refs.form.showForm('Registro de Egreso', 'expense', this.cashCurrent.id)
        },
        handleCloseCash() {
            this.$refs.form.showForm('Cerrar Caja', 'close', this.cashCurrent.id)
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    }
    
}
</script>

<style>

</style>